import { call } from 'redux-saga/effects';
import { storageUnitCache } from 'util/cache/storageUnitCacheIndexedDB';
import type { StorageUnit, StorageUnitsReducerInterface } from './types';

export const findStorageUnitInState = (
  storageUnitsState: StorageUnitsReducerInterface,
  id: string,
): StorageUnit | undefined =>
  [
    ...(storageUnitsState.storageUnits ?? []),
    ...(storageUnitsState.templates ?? []),
    ...(storageUnitsState.approvedFiles ?? []),
    ...(storageUnitsState.archived ?? []),
  ].find((unit) => unit.id === id);

export function* clearCachedStorageUnitTree(
  id: string,
  visited = new Set<string>(),
): Generator<unknown, void, unknown> {
  if (visited.has(id)) {
    return;
  }
  visited.add(id);

  const children = (yield call(
    [storageUnitCache, storageUnitCache.getAllByParent],
    id,
  )) as StorageUnit[];
  for (const child of children) {
    yield* clearCachedStorageUnitTree(child.id, visited);
  }
  yield storageUnitCache.clearOne(id);
}
